import glamorous from 'glamorous';

const HomeHeader = glamorous.header({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 16,
  paddingBottom: 64,
  background: 'radial-gradient(ellipse at center, #5d0060 0%,#560646 50%,#6b0242 100%)',
});

export default HomeHeader;



// WEBPACK FOOTER //
// ./src/components/layout/HomeHeader.js